/**
 * @generated SignedSource<<ec932e447525e2f5df139af5626e3ea7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
  readonly " $fragmentType": "PdpRespDetailTabs_viewer";
};
export type PdpRespDetailTabs_viewer$key = {
  readonly " $data"?: PdpRespDetailTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "89b00ef269eadacf16463602e785b590";

export default node;
